import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import Modal from 'react-native-modal';

import Colors from '../../constants/Colors';
import { useAuthState } from '../../contexts/authentication';
import useAppNavigation from '../../hooks/useAppNavigation';
import useColorScheme from '../../hooks/useColorScheme';
import {
  ReferralContent,
  RefferalLink,
  ShareInviteLinkButton,
} from '../../screens/ReferAFriend';
import { referralLinkPrefix } from '../../utils/referral';
import ModalCloseButton from '../ModalCloseButton';
import { TransparentRow } from '../Row';
import { TextBodySmall, TextCta, TextCtaButton, TextH3 } from '../StyledText';
import { TransparentView, View, ViewWithClassname } from '../Themed';

export default function ReferAFriendModalTrigger() {
  const { navigate } = useAppNavigation();

  const [isVisible, setIsVisible] = useState(false);
  const hide = () => setIsVisible(false);

  const { parent } = useAuthState();

  const theme = useColorScheme();

  const onSharePress = (link: string) => {
    // if (navigator && 'share' in navigator) {
    //   navigator.share({
    //     title,
    //     text: `Hey, you get $25 in credit you can use to book child care on Bumo when you sign up using my referral link: ${link}. Terms apply.`,
    //     url: link,
    //   });
    //   return;
    // }
    // setIsOpen(link);
  };

  if (!parent) {
    return null;
  }

  const link = `${referralLinkPrefix}${parent.referralCode}`;

  return (
    <>
      <TextBodySmall
        style={{
          cursor: 'pointer',
          textDecorationLine: 'underline',
        }}
        onPress={() => setIsVisible(true)}
      >
        Refer a friend
      </TextBodySmall>

      <Modal
        useNativeDriver
        isVisible={isVisible}
        onBackdropPress={hide}
        style={{ margin: 0 }}
        hideModalContentWhileAnimating
        testID="forgot-password-modal-container"
      >
        <View style={styles.modalContainer}>
          <TransparentRow
            style={{
              paddingVertical: 12,
              paddingTop: 24,
              borderBottomWidth: 1,
              borderBottomColor: Colors[theme].lines,
            }}
          >
            <TextCtaButton>
              Refer friends - Give $25 and get $25 💰{' '}
            </TextCtaButton>
            <ModalCloseButton
              onPress={hide}
              absolute
              style={{ top: 12, right: 12, opacity: 0.8 }}
            />
          </TransparentRow>
          <TransparentView style={{ padding: 24 }}>
            <TextBodySmall style={{ marginBottom: 24, textAlign: 'center' }}>
              Invite your friends and give them $25 and you get $25 in
              BumoCredit which you each can use to book child care on Bumo. It’s
              a win win! 😎{' '}
            </TextBodySmall>
            <RefferalLink link={link} />
            <ShareInviteLinkButton
              link={link}
            />
          </TransparentView>
        </View>
      </Modal>
    </>
  );
}

const styles = StyleSheet.create({
  modalContainer: {
    borderRadius: 20,
    minHeight: 100,
    maxWidth: 500,
    width: '100%',
    alignSelf: 'center',
  },
});
